export default "__VITE_ASSET__Dd9xK8li__"